import { useDispatch } from "react-redux"
import { hideToast, showToast } from "../redux/guest-slices/other.slice"

export const useToast = () => {
  const dispatch = useDispatch()

  const show = (options) => {
    dispatch(showToast({
      message: options.message,
      type: options.type || "success",
      duration: options.duration || 2000,
      position: options.position || { vertical: "top", horizontal: "right" }
    }))
  }

  return {
    show,
    hide: () => dispatch(hideToast()),
    info: (message, duration) => show({ type: "info", message, duration }),
    error: (message, duration) => show({ type: "error", message, duration }),
    warning: (message, duration) => show({ type: "warning", message, duration }),
    success: (message, duration) => show({ type: "success", message, duration }),
  }
}